/** Puffer PufferWithdrawalManager — per-id detail getter.
 *  Address on chain 1: `0xDdA0483184E75a5579ef9635ED14BacCf9d50283`.
 *
 *  No user-keyed on-chain storage; enumeration only via the
 *  `WithdrawalRequested` event. Reader accepts caller-supplied
 *  withdrawal indices (captured from the tx receipt) and reads detail
 *  per-id. `getFinalizedWithdrawalBatch()` returns the highest batch
 *  that has settled — a request is claimable iff
 *  `request.batchIdx <= finalizedBatch`. */
export const PufferWithdrawalManagerAbi = [
  {
    name: 'getWithdrawal',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'withdrawalIdx' }],
    outputs: [
      {
        type: 'tuple',
        components: [
          { type: 'uint128', name: 'pufETHAmount' },
          { type: 'uint128', name: 'pufETHToETHExchangeRate' },
          { type: 'address', name: 'recipient' },
        ],
      },
    ],
  },
  {
    name: 'getFinalizedWithdrawalBatch',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'BATCH_SIZE',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
